import styled from 'styled-components';

//  language=SCSS
export default styled.div`
  & {
    margin-left: 300px;
    padding: 40px 60px;
    max-width: 600px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Content/ContentWrapper.js